import { Type } from "@angular/core";
import { CreateEditLabelComponent } from "./create-edit-label.component";

export const CREATE_EDIT_LABEL_DIRECTIVES: Type<any>[] = [
  CreateEditLabelComponent
];
